import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/react-hooks';
import Modal from 'react-modal';
import { positions, Provider as AlertProvider } from 'react-alert';
import apolloClient from './services/apollo';
import './index.css';
import App from './App';
import { ChatProvider } from './services/ChatContext';
import AlertSnack from './components/alert-snack/AlertSnack';
import { NotificationProvider } from './services/NotificationContext';
import { MobileProvider } from './services/MobileContext';
import { OrganizationProvider } from './services/organizationContext';

const root = document.getElementById('root');
Modal.setAppElement(root);

const AlertOptions = {
  timeout: 4000,
  position: positions.BOTTOM_CENTER,
  containerStyle: {
    zIndex: 222222222,
  },
};

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <AlertProvider template={AlertSnack} {...AlertOptions}>
        <ChatProvider>
          <NotificationProvider>
            <MobileProvider>
              <OrganizationProvider>
                <App />
              </OrganizationProvider>
            </MobileProvider>
          </NotificationProvider>
        </ChatProvider>
      </AlertProvider>
    </ApolloProvider>
  </React.StrictMode>,
  root,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
